import React from "react";
import { Button, HStack, Text } from "@chakra-ui/react";
import { QuestionIcon } from "../../styles/icons";

interface GuideFloatingActionButtonProps {
  onClick: () => void;
}

export const GuideFloatingActionButton = ({
  onClick,
}: GuideFloatingActionButtonProps) => {
  return (
    <Button
      position="fixed"
      bottom="24px"
      right="24px"
      bg="cherryRed.100"
      color="white"
      borderRadius="full"
      height="56px"
      paddingLeft="16px"
      paddingRight="24px"
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      _hover={{
        bg: "#AD1457",
        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
      }}
      _active={{
        bg: "#880E4F",
      }}
      onClick={onClick}
      zIndex={1000}
    >
      <HStack spacing={2}>
        <QuestionIcon fontSize="20px" />
        <Text fontWeight="semibold" fontSize="md">
          Guide
        </Text>
      </HStack>
    </Button>
  );
};
